import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Icon, Tag, Menu, Popconfirm } from 'antd';
import moment from 'moment';
import { CAMPAIGN_STATUSES } from '../../../Utils';
import TEXTS from '../../../locale/texts';

export const _allCampaignColumns = function(activeItemId, history, lang) {
  const activeCampaignId = activeItemId;
  const renderMenu = ({ status, smsCount }) => {
    return (
      <Menu>
        {status === 'DRAFT' &&
          <Menu.Item key="edit-campaign" data-action="edit-campaign" data-id={activeCampaignId}>
            <Icon type="edit" style={{position: 'relative', top: -3}} />
            {TEXTS.btnEditBulkSMS[lang]}
          </Menu.Item>}
        <Menu.Item key="details-campaign" data-action="details-campaign" data-id={activeCampaignId}>
          <Icon type="idcard" style={{position: 'relative', top: -3}} />
          {TEXTS.btnDetailsCampaign[lang]}
        </Menu.Item>
        <Menu.Item key="copy-campaign" data-action="copy-campaign" data-id={activeCampaignId}>
          <Icon type="copy" style={{position: 'relative', top: -3}} />
          {TEXTS.btnCopyCampaign[lang]}
        </Menu.Item>
        <Menu.Item key="export-campaign" data-action="export-campaign" data-id={activeCampaignId}>
          <Icon type="export" style={{position: 'relative', top: -3}} />
            {TEXTS.btnExportCampaign[lang]}
        </Menu.Item>
        {smsCount !== 0 &&
          <Menu.Item key="export-msisdns" data-action="export-msisdns" data-id={activeCampaignId}>
            <Icon type="export" style={{position: 'relative', top: -3}} />
            {TEXTS.btnExportRecipientList[lang]}
          </Menu.Item>}
        {status !== 'DRAFT' &&
            <Menu.Item key="mobile-operators-report" data-action="mobile-operators-report" data-id={activeCampaignId}>
                <Icon type="file-text" style={{position: 'relative', top: -3}} />
                {TEXTS.mobileOperatorsReport[lang]}
            </Menu.Item>}
      </Menu>
    );
  };

  return (
    [
      {
        title: TEXTS.thCampaignName[lang],
        dataIndex: 'name',
        width: 165,
        render: (text, record) => {
          return (
            <>
              <Link
                className="ant-btn-link"
                to={`/sms-campaigns/detail/${record.id}`}>
                {text}
              </Link>
              {record.isMsisdnsWithData &&
                <Icon
                  title={TEXTS.campaignIsWithMsisdnsData[lang]}
                  type="solution"
                  style={{position: 'relative', top: -2, marginLeft: 5, fontSize: 12}}
                />}
            </>
          );
        }
      },
      {
        title: TEXTS.thCampaignDate[lang],
        dataIndex: 'scheduleTime',
        width: 120,
        render: (text) => text ? moment(text).format('DD.MM.YYYY HH:mm:ss') : '—'
      },
      {
        title: TEXTS.thSmsBody[lang],
        dataIndex: 'smsBody',
        width: 180,
        render: (text) => text.length > 45 ? <span title={text}>{text.slice(0, 45)}...</span> : text
      },
      {
        title: TEXTS.thReceiversCount[lang],
        dataIndex: 'smsCount',
        width: 115
      },
      {
        title: TEXTS.thReceivedSmsCount[lang],
        dataIndex: 'deliveredCount',
        width: 115,
        render: (text, { status }) => {
          return status.match(/DRAFT|IN_QUEUE/) ? '—' : text;
        }
      },
      {
        title: TEXTS.thUnDeliveredSmsCount[lang],
        width: 115,
        render: (text, { smsCount, deliveredCount }) => {
            return smsCount - deliveredCount;
        }
      },
      {
        width: 90,
        title: TEXTS.thCampaignStatus[lang],
        dataIndex: 'status',
        render: (text) => {
          const status = CAMPAIGN_STATUSES(lang)[text] || {};
          return (
            <Tag color={status.color}>
              {status.text}
            </Tag>
          );
        }
      },
      {
        width: 90,
        onCell: (record) => {
          return {
            onClick: (e) => {
              const action = e.target.getAttribute('data-action');
              switch(action) {
                case 'export-campaign':
                  this.exportMessage({ ...record, exportType: 'campaigns' });
                  break;
                case 'export-msisdns':
                  this.exportMessage({ ...record, exportType: 'exportMsisdns' });
                  break;
                case 'copy-campaign':
                  this.copyCampaign(record.id);
                  break;
                case 'delete-campaign':
                  this.deleteOneOfCampaigns(record);
                  break;
                case 'details-campaign':
                  history.push(`/sms-campaigns/detail/${record.id}`);
                  break;
                case 'edit-campaign':
                  this.editCampaign(record.id);
                  break;
                case 'mobile-operators-report':
                  this.mobileOperatorsReport({ ...record, exportType: 'mobileOperatorsReport' });
                  break;
                default:
                  return false;
              }
            }
          };
        },
        render: (text, record) => {
          const {
            campaignsExportIsLoading,
            campaignsDeleteIsLoading,
            copyCampaignIsLoaded,
            deleteOneOfCampaignsIsLoading
          } = this.state;
          const isLoading = activeCampaignId === record.id
            && (campaignsExportIsLoading || campaignsDeleteIsLoading || copyCampaignIsLoaded);
          return (
            <div style={{display: 'flex'}}>
              <Dropdown overlay={() => renderMenu(record)} placement="bottomRight">
                <Button
                  key={record.id}
                  ghost={!isLoading}
                  type="primary"
                  shape="circle"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: 10,
                    width: 32,
                    height: 32
                  }}
                >
                  <Icon type={isLoading ? 'loading' : 'more'} style={{top: -1, fontSize: 25}} />
                </Button>
              </Dropdown>

              {record.status === 'DRAFT'
                && <Popconfirm
                    placement="bottomRight"
                    okText={TEXTS.yes[lang]} cancelText="Отменить"
                    onConfirm={() => this.deleteOneOfCampaigns(record)}
                    title={TEXTS.areYouSureToDeleteCampaign[lang]}>
                    <Button
                      title={TEXTS.btnDeleteOneDraft[lang]}
                      key={record.id}
                      ghost={(campaignsExportIsLoading || campaignsDeleteIsLoading || copyCampaignIsLoaded)
                        || (!deleteOneOfCampaignsIsLoading && !activeCampaignId)
                        || (!deleteOneOfCampaignsIsLoading && activeCampaignId === record.id)
                        || (deleteOneOfCampaignsIsLoading && activeCampaignId !== record.id)
                      }
                      type="danger"
                      shape="circle"
                      style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                    >
                      <Icon
                        type={activeCampaignId === record.id && deleteOneOfCampaignsIsLoading ? 'loading' : 'delete'}
                        style={{top: -1, fontSize: 16}}
                      />
                    </Button>
                  </Popconfirm>}
            </div>
          );
        }
      }
    ]
  );
};
